/* eslint-disable */
// 스크롤 js
import "./asset/css/reset.css";
import Tab from "./component/tab/Tab.js";
import ProgressBar from "./component/progress/ProgressBar.js";
// import { Slide } from './component/slide/Slide.js';

import Slide from "./component/slide/Slide.js";
import DemoSection from "./component/demo/DemoSection.js";
import Test from "./component/test/Test";
import MainVisual from "./component/mainVisual/MainVisual";
import ContactSection from "./component/contact/ContactSection";

export default function App() {
  // Single page
  return (
    <div className="container">
      {/* <div style={{ marginTop: "1300px" }} /> */}

      {/* 최상단 프로그래스 바 */}
      <ProgressBar />
      {/* test 섹션 */}
      {/* <Test /> */}
      {/* 카드 + 스크롤 테스트 */}
      {/* <Card /> */}
      {/* <div style={{ marginTop: "300px" }} /> */}
      <MainVisual />
      {/* <Slide /> */}
      <Tab />
      <DemoSection />
      <ContactSection />
    </div>
  );
}
